import React from 'react'
import ContentLoader, { Rect } from 'react-content-loader/native'
import { white } from '@qirapagos/lib/theme/colors'

const AccountDetailsSkeleton = () => (
  <ContentLoader
    speed={3}
    interval={0}
    width="100%"
    height="100vh"
    viewBox="0 0 100% 100vh"
    backgroundColor="#e8e7f7"
    foregroundColor={white}
  >
    {/* <Rect x="2.5%" y="3.5vh" rx="8" ry="6" width="45%" height="28%" /> */}
    {/* <Rect x="52.5%" y="3.5vh" rx="8" ry="6" width="45%" height="28%" /> */}
    <Rect x="0.5%" y="5.5vh" rx="0" ry="0" width="100%" height="35%" />
    <Rect x="0.5%" y="40vh" rx="8" ry="50" width="100%" height="50%" />
  </ContentLoader>
)

export default AccountDetailsSkeleton
